import(/* webpackMode: "eager", webpackExports: ["ResetPasswordForm"] */ "/vercel/path0/apps/web/src/app/[locale]/(guest)/reset-password/components/ResetPasswordForm.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/[locale]/(guest)/reset-password/resetPassword.module.css");
